var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"excellent_rates_grap",attrs:{"id":'excellent_rates_grap' + this.id_type}})
}
var staticRenderFns = []

export { render, staticRenderFns }